import { createFileRoute } from '@tanstack/react-router';
import JobReportsView from '../jobs/reports/job-reports-view';

export const Route = createFileRoute('/reports/$reportId')({ component: JobReportsView });
